import React from 'react';
import CommonHeader from 'components/common/headers/CommonHeader';
import { ComparisonPageType } from 'store/ui-stores/comparison/comparisonStore';
import { useQueryParams } from 'global/hooks/useQuery';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { useHistory } from 'react-router-dom';
import { createStyles } from './styles';

export interface ComparisonHeaderProps {
  type: ComparisonPageType;
}
export interface HeaderInfo {
  title: string;
  subtitle: string;
  onRedirect: () => void;
}
export type HeaderTitlesMap = {
  [key in ComparisonPageType]: HeaderInfo;
};

const ComparisonHeader = ({ type }: ComparisonHeaderProps): JSX.Element => {
  const query = useQueryParams();
  const history = useHistory();
  const productLineId = query.get('productLineId') || '';
  const cartId = query.get('cartId') || '';
  const groupId = query.get('groupId') || '';

  const redirectToBrowsingPage = (): void => {
    history.push(`/browsing?groupId=${groupId}&cartId=${cartId}&productLineId=${productLineId}&cartType=browsing`);
  };

  const headerTitles: HeaderTitlesMap = Object.freeze({
    cart: {
      title: 'Compare Added Plans',
      subtitle: '',
      onRedirect: redirectToBrowsingPage,
    },
    variants: {
      title: 'Current Plan Variants',
      subtitle: '',
      onRedirect: redirectToBrowsingPage,
    },
    portfolios: {
      title: 'Compare Selected Plans',
      subtitle: '',
      onRedirect: redirectToBrowsingPage,
    },
    details: {
      title: 'Plan Details',
      subtitle: '',
      onRedirect: redirectToBrowsingPage,
    },
    'config-portfolio': {
      title: 'Portfolio Configurations',
      subtitle: '',
      onRedirect: redirectToBrowsingPage,
    },
    popular: {
      title: 'Plan Details',
      subtitle: '',
      onRedirect: () => {
        history.push(
          `/popular-plans?groupId=${groupId}&cartId=${cartId}&productLineId=${productLineId}&cartType=popular`,
        );
      },
    },
    // cart page
    'proposal-details': {
      title: 'Plan Details',
      subtitle: '',
      onRedirect: () => {
        history.goBack();
      },
    },
    'all-portfolios': {
      title: `Compare All ${
        productLineId ? PRODUCT_LINES_CONTENT_MAP[productLineId as ProductLineId].label : ''
      } Plans`,
      subtitle: '',
      onRedirect: redirectToBrowsingPage,
    },
  });

  const classes = createStyles();
  return (
    <div>
      <CommonHeader
        title={(type && headerTitles[type]?.title) || ''}
        subtitle={(type && headerTitles[type]?.subtitle) || ''}
        headerClassName={classes.comparisonHeader}
        onRedirect={(type && headerTitles[type]?.onRedirect) || undefined}
      />
    </div>
  );
};

export default ComparisonHeader;
